import { ReactNode } from "react";
import { Td } from "@chakra-ui/react";

const TableCell = ({
	children,
	isNumeric,
	maxW,
	color = "black",
	onClick,
}: {
	children: ReactNode;
	isNumeric?: boolean;
	maxW?: string;
	color?: string;
	onClick?: () => void;
}) => {
	return (
		<Td
			color={color}
			maxW={maxW || "140px"}
			overflow={maxW === "auto" ? "initial" : "hidden"}
			textOverflow={maxW === "auto" ? "initial" : "ellipsis"}
			isNumeric={isNumeric}
			onClick={onClick || undefined}
		>
			{children}
		</Td>
	);
};

export default TableCell;
